"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalReportFieldTypeToJSON = exports.InternalReportFieldTypeFromJSONTyped = exports.InternalReportFieldTypeFromJSON = exports.InternalReportFieldType = void 0;
/**
 *
 * @export
 */
exports.InternalReportFieldType = {
    CompletionRateCpcl: 'COMPLETION_RATE_CPCL',
    CompletionRateCpm: 'COMPLETION_RATE_CPM',
    CompletionRatePodcast: 'COMPLETION_RATE_PODCAST',
    SkadTotalInstalls: 'SKAD_TOTAL_INSTALLS',
    SpaaModeledAddToCart: 'SPAA_MODELED_ADD_TO_CART',
    SpaaModeledLead: 'SPAA_MODELED_LEAD',
    SpaaModeledPageView: 'SPAA_MODELED_PAGE_VIEW',
    SpaaModeledPurchase: 'SPAA_MODELED_PURCHASE',
    SpaaUnmodeledAddToCart: 'SPAA_UNMODELED_ADD_TO_CART',
    SpaaUnmodeledLead: 'SPAA_UNMODELED_LEAD',
    SpaaUnmodeledPageView: 'SPAA_UNMODELED_PAGE_VIEW',
    SpaaUnmodeledPurchase: 'SPAA_UNMODELED_PURCHASE',
    KochavaAppInstalls: 'KOCHAVA_APP_INSTALLS',
    AppsflyerAppInstalls: 'APPSFLYER_APP_INSTALLS'
};
function InternalReportFieldTypeFromJSON(json) {
    return InternalReportFieldTypeFromJSONTyped(json, false);
}
exports.InternalReportFieldTypeFromJSON = InternalReportFieldTypeFromJSON;
function InternalReportFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.InternalReportFieldTypeFromJSONTyped = InternalReportFieldTypeFromJSONTyped;
function InternalReportFieldTypeToJSON(value) {
    return value;
}
exports.InternalReportFieldTypeToJSON = InternalReportFieldTypeToJSON;
